module.exports = "/packs/images/google_play_badge~793134736fb30551b1cb423c4032726e.gif";